module.exports = __webpack_public_path__ + "static/media/dolyame.2053c4bf.svg";